import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledField = styled(Flex)`
  flex: 1;
  font-size: 12px;
  line-height: 20px;
  color: ${(props) => props.theme.antd?.colorTextSecondary};
  .label {
    font-weight: 500;
    color: ${(props) => props.theme.antd?.colorTextHeading};
  }
`;

export const ActionButtonWrapper = styled.div`
  padding: 8px;
  color: #999b9e;
  &:hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;
